import { render, staticRenderFns } from "./base-btn.vue?vue&type=template&id=68d745c4"
import script from "./base-btn.ts?vue&type=script&lang=ts&external"
export * from "./base-btn.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d745c4')) {
      api.createRecord('68d745c4', component.options)
    } else {
      api.reload('68d745c4', component.options)
    }
    module.hot.accept("./base-btn.vue?vue&type=template&id=68d745c4", function () {
      api.rerender('68d745c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Btn/base-btn.vue"
export default component.exports